import { Component, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-payment-flow',
  templateUrl: './payment-flow.component.html',
})

export class PaymentFlowComponent{
  promptPaymentConfirmation: boolean = false;
  selectedPaymentMethod: any = {};

  processPayment(e: any){
    this.selectedPaymentMethod = e;
    this.promptPaymentConfirmation = true;
  }
}
